import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useDeviceSize } from '@hooks';
import { Popup } from '@elements';
import { StyledContent, StyledHeader, StyledPopup } from './confirm.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ConfirmPopup = function ConfirmPopup(_ref) {
  var popUp = _ref.popUp,
      rejectPopup = _ref.rejectPopup,
      acceptPopup = _ref.acceptPopup;
  var header = popUp && popUp.data && popUp.data.header;
  var body = popUp && popUp.data && popUp.data.body;
  var rejectButton = popUp && popUp.data && popUp.data.rejectButton;
  var acceptButton = popUp && popUp.data && popUp.data.acceptButton;

  var _useDeviceSize = useDeviceSize(),
      mobile = _useDeviceSize.mobile;

  return /*#__PURE__*/_jsxs(StyledPopup, {
    width: 456,
    fullWidth: true,
    popUp: popUp,
    children: [/*#__PURE__*/_jsx(Popup.Title, {
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: /*#__PURE__*/_jsx(Typography, {
          variant: mobile ? 'h5' : 'h4',
          color: "tuna",
          fontWeight: 700,
          children: header
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Content, {
      children: /*#__PURE__*/_jsx(StyledContent, {
        flexDirection: "column",
        children: body && /*#__PURE__*/_jsx(Typography, {
          color: "tuna",
          variant: mobile ? 'body1' : 'h5',
          fontWeight: 400,
          children: body
        })
      })
    }), /*#__PURE__*/_jsx(Popup.Footer, {
      children: /*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        children: /*#__PURE__*/_jsxs(Stack, {
          direction: "row",
          spacing: 1.5,
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "contained",
            color: "secondary",
            size: "medium",
            onClick: rejectPopup,
            children: rejectButton
          }), /*#__PURE__*/_jsx(Button, {
            variant: "contained",
            size: "medium",
            onClick: acceptPopup,
            children: acceptButton
          })]
        })
      })
    })]
  });
};

export { ConfirmPopup };